/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC} from 'react'
import classNames from 'classnames'
import { IReportDto } from '../Report.model'
import { useIntl } from 'react-intl'
import { IconLabelContent } from '../../../common/component/IconLabelContent'
import { parseLocalDate } from '../../../util/Locale'

interface Props {
  data: IReportDto
  rowSelected?: string | undefined
  backgroundClass?: string
  hoverBackgroundClass?: string
  onRowClick?: (id: string) => void
}

export const ReportListItem: FC<Props> = ({
  data,
  rowSelected,
  backgroundClass = 'bg-light-primary',
  hoverBackgroundClass = 'bg-hover-light-primary',
  onRowClick,
}: Props) => {
  const intl = useIntl()
  const backGroundClasses = {}
  backGroundClasses[`d-flex flex-stack py-2 ${backgroundClass}`] = data.id === rowSelected

  const hoverBackGroundClasses = {}
  hoverBackGroundClasses[`d-flex flex-stack py-2 ${hoverBackgroundClass}`] = data.id !== rowSelected

  const buildAssetTypeDescriptionLine = (data: IReportDto) => {
    return `${data.asset.family} | ${data.asset.area} | ${data.asset.brand} | ${data.asset.model} | ${data.asset.serial}`
  }

  const buildAssetDetailsLine = (data: IReportDto) => {
    return `${data.address}`
  }

  return (
    <div
      className={classNames(backGroundClasses, hoverBackGroundClasses)}
      onClick={() => onRowClick && onRowClick(data.id)}
    >
      <div className='d-flex flex-stack'>
        <div className='d-flex align-items-center'>
          <div className='ms-2'>
            <div className='fs-7 cursor-pointer'>
              <span className='text-primary mb-2'>
                {`${parseLocalDate(data.createdAt, intl.formatMessage({id: 'I18N.LOCALE'}))}`}
              </span>
              <span className='text-gray-800 ms-2 me-2 mb-2'>-</span>
              <span className='fw-bolder mb-2'>{`${data.client.displayName} `}</span>
              <span className='text-gray-600 ms-2 me-2 mb-2'>-</span>
              <span className='text-primary mb-2'>{data.sequence}</span>
            </div>

            <div className='d-flex justify-content-start'>
              <div className='d-flex align-items-center fs-8'>
                <span className='text-gray-600'>{buildAssetTypeDescriptionLine(data)}</span>
              </div>
            </div>

            <div className='d-flex justify-content-start'>
              <div className='d-flex align-items-center fs-8'>
                <span className='text-gray-600'>{buildAssetDetailsLine(data)}</span>
              </div>
            </div>

            <div className='d-flex justify-content-start align-items-center'>
              <IconLabelContent
                title={
                  data.contract
                    ? `${intl.formatMessage({id: 'UTIL.CONTRACT'})} #${data.contract.sequence}`
                    : ''
                }
                active={!!data.contract}
                icon='bi bi-vector-pen'
              />

              <IconLabelContent
                title={
                  data.status === 'PENDING'
                    ? intl.formatMessage({id: 'TITLE.STATUS.PENDING'})
                    : intl.formatMessage({id: 'TITLE.STATUS.COMPLETE'})
                }
                active={data.status !== 'PENDING'}
                icon='bi bi-check-circle'
              />

              <IconLabelContent
                title={
                  data.shared
                    ? intl.formatMessage({id: 'TITLE.EMAIL.SHARED'})
                    : intl.formatMessage({id: 'TITLE.EMAIL.UNSHARED'})
                }
                active={data.shared}
                icon='bi bi-envelope'
              />

              <IconLabelContent
                title={
                  data.totalAttachment > 0
                    ? intl
                        .formatMessage({
                          id:
                            data.totalAttachment === 1
                              ? 'TITLE.ATTACHMENT.TOTAL_SINGLE'
                              : 'TITLE.ATTACHMENT.TOTAL_MULTIPLE',
                        })
                        .replace(/%s/g, `${data.totalAttachment}`)
                    : intl.formatMessage({id: 'TITLE.ATTACHMENT.ZERO'})
                }
                active={data.totalAttachment > 0}
                labelValue={`${data.totalAttachment || 0}`}
                icon='bi bi-paperclip'
              />

              {data.workOrderRequest &&
                data.workOrderRequest.lines &&
                data.workOrderRequest.lines.length > 0 && (
                  <IconLabelContent
                    title={
                      data.ticketReferences && data.ticketReferences.length > 0
                        ? intl.formatMessage({id: 'REPORT.WORK_ORDER_REQUEST.COMPLETE.LABEL'})
                        : intl.formatMessage({id: 'REPORT.WORK_ORDER_REQUEST.PENDING.LABEL'})
                    }
                    active={(data.ticketReferences && data.ticketReferences.length > 0) || false}
                    icon={'bi bi-wrench-adjustable'}
                  />
                )}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
